import React, { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
import { MobileMenu } from './MobileMenu';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <>
      <header className={`fixed top-0 left-0 right-0 z-30 transition-all duration-300 ${isScrolled ? 'bg-[#FFF8F0] shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-148">
        <div className="container mx-auto px-4 md:px-8 flex justify-between items-center h-[60px] md:h-auto" data-id="element-149">
          {/* Logo */}
          <Link to="/" className="flex items-center z-40 relative group" data-id="element-150">
            <span className="font-heading text-2xl md:text-3xl font-bold text-[#2D1A1A] tracking-tight group-hover:text-[#E91E8C] transition-colors" data-id="element-151">
              Butter Blonde
            </span>
            <span className="text-[#F5D76E] ml-1 text-xl md:text-2xl" data-id="element-152">✦</span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-153">
            <NavLink to="/" className={({
            isActive
          }) => `font-body font-medium text-[15px] uppercase tracking-wide transition-colors hover:text-[#E91E8C] ${isActive ? 'text-[#E91E8C] border-b-2 border-[#E91E8C] pb-1' : 'text-[#2D1A1A]'}`} data-id="element-154">
              Home
            </NavLink>
            <NavLink to="/collections" className={({
            isActive
          }) => `font-body font-medium text-[15px] uppercase tracking-wide transition-colors hover:text-[#E91E8C] ${isActive ? 'text-[#E91E8C] border-b-2 border-[#E91E8C] pb-1' : 'text-[#2D1A1A]'}`} data-id="element-155">
              Collections
            </NavLink>
            <NavLink to="/about" className={({
            isActive
          }) => `font-body font-medium text-[15px] uppercase tracking-wide transition-colors hover:text-[#E91E8C] ${isActive ? 'text-[#E91E8C] border-b-2 border-[#E91E8C] pb-1' : 'text-[#2D1A1A]'}`} data-id="element-156">
              About
            </NavLink>
            <NavLink to="/contact" className={({
            isActive
          }) => `font-body font-medium text-[15px] uppercase tracking-wide transition-colors hover:text-[#E91E8C] ${isActive ? 'text-[#E91E8C] border-b-2 border-[#E91E8C] pb-1' : 'text-[#2D1A1A]'}`} data-id="element-157">
              Contact
            </NavLink>
            <a href="https://shop.butter-blonde.com" target="_blank" rel="noopener noreferrer" className="font-body font-bold text-[15px] uppercase tracking-wide text-[#FFFFFF] bg-[#E91E8C] px-5 py-2 rounded-full hover:bg-[#C21472] transition-colors shadow-sm" data-id="element-158">
              Shop
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-[#2D1A1A] hover:text-[#E91E8C] transition-colors z-40" onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-159">
            <MenuIcon className="w-6 h-6" data-id="element-160" />
          </button>
        </div>
      </header>

      <MobileMenu isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} data-id="element-161" />
    </>;
}